import React from 'react';
import { useSelector } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { ViewSectionRow } from '../../../components/layouts/viewSectionRow';
import { ViewTable } from '../../../components/layouts/viewTable';
import { RootState } from '../../../store';
import { DonationFinancialsPlatformSectionRow } from '../../donation/view/components/donationFinancialsPlatformSectionRow';
import { OFFLINE_SALE_TYPE } from '../../campaign/constants';

import CurrencyHelper from '../../../helpers/currencyHelper';
import { Record } from '../../../modules/bin/utility';

interface ITicketInvoiceTableProps {
  showEmptyFields: boolean;
  displayOrgCurrency: boolean;
}

export const TicketPaymentTable = ({
  showEmptyFields,
  displayOrgCurrency
}: ITicketInvoiceTableProps) => {
  const ticketing = useSelector((state: RootState) => state.ticketing);
  const session = useSelector((state: RootState) => state.session);
  const recordData = ticketing.record?.data?.data;
  if (!recordData) {
    return null;
  }
  const customPaymentPlatform =
    ticketing.relatedRecord?.data?.data?.paymentPlatform;
  const isRelatedLoaded = Record.isRecordReady(ticketing.relatedRecord);
  const currency = displayOrgCurrency
    ? recordData?.organization.currency
    : recordData?.currency;
  const feeDetails = recordData?.financials?.feeDetail;

  let amount = recordData?.amount;
  let stripeFee =
    (feeDetails?.paymentPlatformFee ?? 0) + (feeDetails?.paymentPlatformFeeTax ?? 0);
  let { fee = 0, feeTax = 0, saleTax = 0 } = feeDetails ?? {};

  if (displayOrgCurrency) {
    const exchangeRate = recordData?.financials.exchangeRate;

    amount *= exchangeRate;
    stripeFee *= exchangeRate;
    fee *= exchangeRate;
    feeTax *= exchangeRate;
    saleTax *= exchangeRate;
  }

  const type = recordData.type;
  const isOffline = type == OFFLINE_SALE_TYPE;

  return (
    <div className="ticket-payment-table">
      <ViewTable
        title={
          <Translate value="ticketing.edit.invoice-information.payment.label" />
        }
      >
        <ViewSectionRow
          isShowEmptyFields={showEmptyFields}
          title="ticketing.edit.invoice-information.amount.label"
          data={CurrencyHelper.formatCurrency(amount, currency)}
        />
        <ViewSectionRow
          isShowEmptyFields={showEmptyFields}
          title="ticketing.edit.invoice-information.fee.stripe.label"
          data={CurrencyHelper.formatCurrency(stripeFee, currency)}
        />
        <ViewSectionRow
          isShowEmptyFields={showEmptyFields}
          title="ticketing.edit.invoice-information.fee.tax.label"
          data={
            <>
              {CurrencyHelper.formatCurrency(fee, currency)} (
              {CurrencyHelper.formatCurrency(feeTax, currency)})
            </>
          }
        />
        <ViewSectionRow
          isShowEmptyFields={showEmptyFields}
          title="ticketing.edit.invoice-information.fee.sales-tax.label"
          data={CurrencyHelper.formatCurrency(saleTax, currency)}
        />
        {!isOffline && (
          <DonationFinancialsPlatformSectionRow
            title="ticketing.edit.invoice-information.gateway.label"
            data={recordData?.financials}
            isPaymentPlatformsLoaded={isRelatedLoaded}
            isSystemAdmin={session.isSystemAdmin}
            customPaymentPlatform={customPaymentPlatform}
          />
        )}
      </ViewTable>
    </div>
  );
};
